<template>
  <section>
    <RegisterHeader />
    <RegisterIntro />
    <RegisterBullets />
    <RegisterHow />
    <RegisterPricing />
    <RegisterMore />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Register',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['about-members-register'] || {}
    }
  },
  mounted() {
    console.log('about-members-register', this.$wp.pages['about-members-register'])
  }
}
</script>
